module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/13-0cc1e4bd5048bc8f4437b9c2d393d255.jpg";